<template>
  <div class="date-range-container">
    <div>
      <div class="date-range-arrow">
        <i class="n-i n-i-arrow-right-a"></i>
      </div>
      <div class="filter-time">
        <p>{{todayDate}}</p>
        <p @click="setCurrentDate()">
          <localized-label>dateRangePickerTodayLabel</localized-label>
        </p>
      </div>
    </div>
    <v-form>
      <div xs12 class="mt-3">
        <span class="date-range-text">
          <localized-label>dateRangePickerStartDateLabel</localized-label>
        </span>
        <div>
          <v-layout row>
            <v-flex xs12 sm7 md7>
              <v-menu
                ref="menu"
                class="date-range"
                v-model="dateFromMenu"
                nudge-bottom="38"
                >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-text-field
                      class="date-range-input pr-2"
                      v-model="dateFrom"
                      prepend-inner-icon="n-i n-i-calendar"
                      height="36"
                      readonly
                      solo
                      flat>
                    </v-text-field>
                  </div>
                </template>
                <v-date-picker
                  :weekday-format="getWeekendNames"
                  width="350"
                  color="#38acf0"
                  class="date-range-date pt-2"
                  v-model="dateFrom"
                  :allowed-dates="getAllowedDates"
                  no-title
                  scrollable
                  @change="validateAllowedDays">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <div>
              <v-flex xs12 sm5 md5 class="date-range-timer" d-inline-flex>
                <v-flex >
                  <v-icon class="mt-2 ml-4 n-i n-i-clock"></v-icon>
                </v-flex>
                <v-flex >
                  <v-text-field
                    v-model="dateFromHours"
                    class="date-range-time-input ml-2"
                    :rules="hoursRules"
                    :maxlength="maxAllowedDigits"
                    height="36"
                    solo
                    flat
                    @input="validateDateTime">
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="dateFromMinutes"
                    class="date-range-time-input ml-1"
                    :rules="minutesRules"
                    :maxlength="maxAllowedDigits"
                    height="36"
                    solo
                    flat
                    @input="validateDateTime">
                  </v-text-field>
                </v-flex>
              </v-flex>
            </div>
          </v-layout>
        </div>
      </div>
      <v-flex xs12>
        <v-card color="#d3dadd" flat>
          <span class="date-range-text">
            <localized-label>dateRangePickerEndDateLabel</localized-label>
          </span>
          <v-layout row>
            <v-flex xs12 sm7 md7>
              <v-menu
                ref="menu"
                v-model="dateToMenu"
                nudge-bottom="38"
                >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-text-field
                      class="date-range-input pr-2"
                      v-model="dateTo"
                      prepend-inner-icon="n-i n-i-calendar"
                      height="36"
                      readonly
                      solo
                      flat>
                    </v-text-field>
                  </div>
                </template>
                <v-date-picker
                  :weekday-format="getWeekendNames"
                  width="350"
                  color="#38acf0"
                  class="date-range-date pt-2"
                  v-model="dateTo"
                  :allowed-dates="getAllowedDates"
                  no-title
                  scrollable
                  @change="validateAllowedDays">
                </v-date-picker>
              </v-menu>
            </v-flex>
            <div>
              <v-flex xs12 sm5 md5 class="date-range-timer" d-inline-flex>
                <v-flex >
                  <v-icon class="mt-2 ml-4">n-i n-i-clock</v-icon>
                </v-flex>
                <v-flex >
                  <v-text-field
                    v-model="dateToHours"
                    class="date-range-time-input ml-2"
                    :rules="hoursRules"
                    :maxlength="maxAllowedDigits"
                    height="36"
                    solo
                    flat
                    @input="validateDateTime">
                  </v-text-field>
                </v-flex>
                <v-flex>
                  <v-text-field
                    v-model="dateToMinutes"
                    class="date-range-time-input ml-1"
                    :rules="minutesRules"
                    :maxlength="maxAllowedDigits"
                    height="36"
                    solo
                    flat
                    @input="validateDateTime">
                  </v-text-field>
                </v-flex>
              </v-flex>
            </div>
          </v-layout>
        </v-card>
      </v-flex>
    </v-form>
    <div class="predefined-range">
      <span>
        <localized-label>predefinedRangeChooseLabel</localized-label>
      </span>
      <div class="predefined-select">
        <select v-model="predefinedSelected"
          @change="predefinedRange()">
          <option v-for="(item, index) in predefinedRangeItems"
                  :key="index"
                  :value="item">
            {{translations[`predefinedRange${item.value}Label`]}}
          </option>
        </select>
        <i class="n-i n-i-arrow-down-b"></i>
      </div>
    </div>
    <div class="date-range-buttons">
      <button type="button"
              :class="disabledClass"
              @click="setDateSettings">
        <localized-label>dateRangePickerSaveButtonLabel</localized-label>
      </button>
      <button type="button" @click="clearDateInputs">
        <localized-label>dateRangePickerClearButtonLabel</localized-label>
      </button>
    </div>
    <div class="date-info-message"
         v-if="dateMessage">
      <div class="info-icon"><i class="n-i n-i-info"></i></div>
      <div class="info-divider"></div>
      <div class="info-text">{{dateMessage}}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { momentable } from '../mixins';
import { moment, bus } from '../utility';

export default {
  name: 'DateRangePicker',
  mixins: [
    momentable,
  ],
  data() {
    return {
      predefinedSelected: { value: 'CurrentDate' },
      predefinedRangeItems: [
        { value: 'ChooseRange', default: true },
        { value: 'CurrentDate' },
        { value: 'PreviousDate' },
        { value: 'CurrentWeek' },
        { value: 'PreviousWeek' },
        { value: 'CurrentMonth' },
        { value: 'PreviousMonth' },
      ],
      maxAllowedDigits: 2,
      todayDate: this.formatPickerDate(),
      dateFrom: null,
      dateMessage: null,
      isDisabled: false,
      isDateValid: false,
      dateFromHours: null,
      dateFromMinutes: null,
      dateTo: null,
      dateToHours: null,
      dateToMinutes: null,
      dateFromMenu: false,
      dateToMenu: false,
      timeFrom: null,
      timeTo: null,
      hoursRules: [
        // eslint-disable-next-line
        hour => ((hour >= 0 && hour < 24) || ((this.dateFromHours = '00') && (this.dateToHours = '23'))),
      ],
      minutesRules: [
        // eslint-disable-next-line
        minute => ((minute >= 0 && minute < 60) || ((this.dateFromMinutes = '00') && (this.dateToMinutes = '59'))),
      ],
    };
  },
  mounted() {
    this.setDateSettings();
    bus.$on('restartFilters', () => {
      this.resetDateFilters();
    });
  },
  computed: {
    ...mapGetters([
      'translations',
    ]),
    disabledClass() {
      return this.isDisabled ? 'button-disabled' : false;
    },
  },
  methods: {
    getWeekendNames: date => new Date(date).toString().split(' ')[0].slice(0, -1),
    getAllowedDates(value) {
      return moment.utc(value).isSameOrBefore(moment());
    },
    validateAllowedDays() {
      this.isDisabled = false;
      this.dateMessage = null;
      this.isDateValid = true;
      const days = moment(this.dateTo).diff(moment(this.dateFrom), 'days');
      if (days > 31) {
        this.isDisabled = true;
        this.isDateValid = false;
        this.dateMessage = this.translations.maxAllowedDaysText;
      } else if (moment(this.dateTo).isBefore(moment(this.dateFrom))) {
        this.isDisabled = true;
        this.isDateValid = false;
        this.dateMessage = this.translations.invalidDateInfo;
      } else if (moment(this.dateFrom).isSame(this.dateTo)) {
        this.validateDateTime();
      }
    },
    validateDateTime() {
      this.isDisabled = false;
      this.dateMessage = null;
      this.isDateValid = true;
      const from = moment(`${this.dateFrom}*${this.dateFromHours}:${this.dateFromMinutes}:${'00'}`);
      const to = moment(`${this.dateTo}*${this.dateToHours}:${this.dateToMinutes}:${'59'}`);
      if (moment(this.dateFrom).isSame(this.dateTo)) {
        if (from.isAfter(to) || to.isBefore(from)) {
          this.dateMessage = this.translations.invalidDateInfo;
          this.isDisabled = true;
          this.isDateValid = false;
        }
      }
    },
    clearDateInputs() {
      this.dateFrom = null;
      this.dateFromHours = null;
      this.dateFromMinutes = null;
      this.dateTo = null;
      this.dateToHours = null;
      this.dateToMinutes = null;
    },
    resetDateFilters() {
      this.setCurrentDate();
      this.setDateSettings();
    },
    setDateSettings() {
      if (!this.dateFrom || !this.dateTo) {
        this.setCurrentDate();
      }
      this.dateFrom = this.formatPickerDate(this.dateFrom);
      this.dateTo = this.formatPickerDate(this.dateTo);
      this.timeFrom = this.formatPickerTime(`${this.dateFromHours}:${this.dateFromMinutes}:${'00'}`);
      this.timeTo = this.formatPickerTime(`${this.dateToHours}:${this.dateToMinutes}:${'59'}`);

      this.$emit('datePicker', {
        dateFrom: this.dateFrom,
        dateTo: this.dateTo,
        timeFrom: this.timeFrom,
        timeTo: this.timeTo,
        isDateValid: this.isDateValid,
      });
    },
    setCurrentDate() {
      this.setDateHoursAndMinutes();
      this.dateFrom = this.todayDate;
      this.dateTo = this.todayDate;
      this.validateAllowedDays();
    },
    setPreviousDate() {
      this.dateFrom = moment().subtract(1, 'days').format('YYYY-MM-DD');
      this.dateTo = moment().subtract(1, 'days').format('YYYY-MM-DD');
      this.setDateHoursAndMinutes();
    },
    setCurrentWeek() {
      this.dateFrom = moment().startOf('isoWeek').format('YYYY-MM-DD');
      this.dateTo = moment().endOf('isoWeek').format('YYYY-MM-DD');
      this.setDateHoursAndMinutes();
    },
    setPreviousWeek() {
      this.dateFrom = moment().subtract(1, 'weeks').startOf('isoWeek').format('YYYY-MM-DD');
      this.dateTo = moment().subtract(1, 'weeks').endOf('isoWeek').format('YYYY-MM-DD');
      this.setDateHoursAndMinutes();
    },
    setCurrentMonth() {
      this.dateFrom = moment().startOf('month').format('YYYY-MM-DD');
      this.dateTo = moment().endOf('month').format('YYYY-MM-DD');
      this.setDateHoursAndMinutes();
    },
    setPreviousMonth() {
      this.dateFrom = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
      this.dateTo = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
      this.setDateHoursAndMinutes();
    },
    setDateHoursAndMinutes() {
      this.dateFromHours = '00';
      this.dateFromMinutes = '00';
      this.dateToHours = '23';
      this.dateToMinutes = '59';
    },
    predefinedRange() {
      if (!this.predefinedSelected.default) {
        this[`set${this.predefinedSelected.value}`]();
        this.validateAllowedDays();
      }
    },
  },
};
</script>
<style lang="scss">
.date-clock {
  color: #808b9c;
  display: flex;
  align-items: center;
  padding-right: 30px;
  font-size: 12px;
  div:nth-child(n+1) {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color:#fff;
    height: 36px;
    width: 36px;
    input {
    height: 36px;
    width: 36px;
    }
  }
  div:first-child {
    background-color:#d3dadd;
  }
  div:nth-child(3) {
    margin-left: 5px;
  }
}

.date-range-picker {
  input {
    height: 36px;
    width: 205px;
    margin: 0 2px;
    text-align: center;
    border: none;
    outline: 0;
    float: left;
    background: #fff;
    color: #808b9c;
  }
}
.date-picker-from {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .n-i {
    color: #808b9c;
    position: absolute;
    font-size: 20px !important;
  }
  .placeholder {
    color: #808b9c;
    position: absolute;
    font-size: 12px;
  }
}
.predefined-range {
  display: grid;
  span {
    color: #6b7585;
    font-size: 14px;
  }
  .predefined-select {
    display: flex;
    align-items: center;
    select {
      width: 100%;
      height: 36px;
      padding-left: 10px;
      background-color: #e8ecee;
      color: #808b9c;
      &:focus {
        outline: none;
      }
    }
    .n-i {
      color:#808b9c;
      font-size: 12px !important;
      position: absolute;
      right: 0;
      padding-right: 20px;
    }
  }
}

.date-range-container {
  display: grid;
  width: 400px;
  background-color: #d3dadd;
  left: 0;
  padding: 10px 10px 20px 20px;
  position: absolute;
  margin-top: 13px;
  z-index: 10;
}
.date-range-arrow {
  background-color: $datePickerBlue;
  width: 40px;
  height: 30px;
  text-align: center;
  float: left;
  border-radius: 2px;
  color: white;
  padding: 5px;
  cursor: pointer;
}
.date-range-buttons {
  padding-top: 20px;
  button {
    width: 120px;
    height: 32px;
    font-size: 14px;
    color: #fff;
    &:focus { outline:0; }
    &:first-child {
      background-color: #38acf0;
    }
    &:last-child {
       background-color: #8791a2;
       margin-left: 2px;
    }
  }
}

.date-info-message {
  display: flex;
  align-items: center;
  background: #e538352a;
  height: 36px;
  margin-top: 20px;
  color: #e53935;
  padding-left: 10px;
  border: 1px solid #e53935;
  border-radius: 5px;
  .info-icon {
    display: flex;
    .n-i {
      font-size: 14px;
      color:  #e53935;
    }
  }
  .info-divider {
    width: 1px;
    height: 18px;
    opacity: 0.5;
    background-color: #e53935;
    margin-left: 7px;
  }
  .info-text {
    padding-left: 7px;
  }
}

.button-disabled {
  pointer-events: none;
  opacity: 0.4;
}

.date-range-text {
  color: #6b7585;
  font-size: 14px;
}

.date-range-date {
  .v-date-picker-header {
    font-size: 17px;
    height: 36px;
    padding-top: 5px;
    background: #929cac;
    padding: 0;
  }

  .v-date-picker-header__value button {
    color: #fffdf9 !important;
    font-weight: 400;
  }

  .v-btn .v-btn__content .v-icon {
    color: #fffdf9;
    font-size: 18px;
  }

  .v-date-picker-table {
    height: auto;
    .v-btn {
    width: 47px;
    height: 37px;
    border-radius: 0;
    font-weight: 400;
    }
  }

  .v-btn--icon {
    &:before { border-radius: 0; }
  }

  .v-date-picker-table--date th {
    font-weight: 300;
    font-size: 11px;
    color: #8b9898;
    border-bottom: 1px dotted;
  }
}

.date-range-timer {
  .theme--light.v-input {
    width: 39px;
  }
}

.date-range-action-buttons {
  .theme--light.v-btn {
    width: 120px;
    height: 32px !important;
    color: white;
    padding: 0;
    margin-right: -6px;
  }
}

.date-range-arrow,
.date-range-input,
.date-range-timer {
  .n-i { font-size: 20px !important; }
}

.date-range-timer {
  .n-i { padding-top: 4px; }
}

.filter-time {
  float: left;
  margin-left: 8px;
  p {
    margin-bottom: -2px;
    color: #6b7585;
    &:first-child {
      font-size: 17px;
      margin-top: -4px;
    }

    &:nth-child(2) {
      font-size: 10px;

      &:hover {
        color: #38acf0;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
}

.theme--light.v-list {
  background: #e8ecee;
  border: solid $datePickerBlue 1px;
  margin-top: 33px;
}

.v-list__tile__title {
  font-size: 14px;
  color: $datePickerBlueGrey2;
}

.v-text-field.v-text-field--solo .v-text-field__slot {
  font-size: 12px;
  text-align: center;
}

.v-menu__content {
  border-radius: 4px;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  .theme--light {
    border-radius: 0;
  }
}

.v-text-field input {
  text-align: center;
}

.v-list__tile {
  height: 28px;
}

.v-input input {
  color: $datePickerBlueGrey1 !important;
}

.theme--light.v-select {
  .v-select__selections {
    color: $datePickerBlueGrey1;
  }
}
</style>
